<div class="terms-of-use">
  <div class="terms-of-use__container">
    <img [src]="'assets/acc-auth0.jpg'" class="acc-logo" alt="ACC Logo" />
    <h1 class="terms-of-use__title">
      ACC DATA HUB TERMS OF USE<br />
      (DEEPROOTS – FREE ACCESS VERSION)
    </h1>

    <div class="terms-of-use__effective-date">Last Updated: June 30, 2026</div>

    <div class="terms-of-use__section">
      <p>
        These Terms of Use (“Terms”) govern your access to and use of the ACC
        Data Hub (the “Data Hub”) made available by or on behalf of ACC Data Hub
        LLC (“Company,” “we,” “us,” or “our”). The Data Hub is intended for use
        by small businesses and other organizations and the individuals
        authorized to act on their behalf (collectively, “you” or “End User”).
        Please carefully review these Terms before accessing the Data Hub.
      </p>
    </div>

    <div class="terms-of-use__notice">
      <p>
        BY ACCESSING OR USING THE DATA HUB, OR BY CLICKING THE “AGREE” BUTTON,
        YOU (A) ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND THESE TERMS; (B)
        REPRESENT THAT YOU ARE 18 YEARS OF AGE OR OLDER AND ARE AUTHORIZED TO
        ENTER INTO THESE TERMS ON BEHALF OF THE BUSINESS OR ENTITY YOU
        REPRESENT; AND (C) ACCEPT THESE TERMS AND AGREE THAT YOU ARE LEGALLY
        BOUND BY THEM. IF YOU DO NOT AGREE TO THESE TERMS, DO NOT ACCESS OR USE
        THE DATA HUB.
      </p>
    </div>

    <div class="terms-of-use__section">
      <p>
        These Terms supplement, and are in addition to, the ACC Data Hub End
        User License Agreement (the “EULA”), the ACC Data Hub Trial Period Terms
        and Conditions (where applicable), and the Company’s Privacy Policy (the
        “Privacy Policy”), each of which is incorporated into these Terms by
        reference. In the event of a conflict between these Terms and the EULA,
        the EULA shall govern with respect to the subject matter addressed
        therein.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>
        1. Nature of the Platform; No Loan Application or Funding Guarantee
      </h2>
      <p>
        The Data Hub is a resource-connection platform. Its purpose is to help
        connect businesses with resources and with organizations that have been
        onboarded to the Data Hub (referred to herein as the “Onboarded
        Organizations,” with each, an “Onboarded Organization”). While some
        Onboarded Organizations may offer loans, or other forms of financing or
        services, you acknowledge and agree to the following:
      </p>
      <ul>
        <li>
          <strong>Submitting information is not a loan application.</strong>
          Adding, entering, or uploading details or information to the ACC
          DeepRoots Data Hub does not constitute a loan application, a request
          for credit, or an application for any product or service offered by
          the Company or any Onboarded Organization.
        </li>
        <li>
          <strong>No credit pull.</strong> Neither the Company nor ACC DeepRoots
          will pull, request, or obtain your credit report or credit score as a
          result of your use of the Data Hub or your submission of information
          to it. Any credit review, if applicable, would occur only later and
          separately through a direct relationship between you and an Onboarded
          Organization, subject to that organization’s own terms and your
          separate authorization. Company and ACC DeepRoots will have no
          involvement at that stage.
        </li>
        <li>
          <strong>No guarantee of funding, connection, or contact.</strong> The
          Company does not guarantee that your use of the Data Hub will result
          in any funding, financing, loan, connection, introduction, response,
          or contact from any Onboarded Organization or other party. The Company
          makes no representation that any Onboarded Organization will review
          your information, reach out to you, or do business with you.
        </li>
        <li>
          <strong>Independent providers.</strong> Onboarded Organizations are
          independent third parties. Any loan, financing, product, or service
          they may offer is provided solely by that organization and is governed
          by that organization’s own terms, eligibility criteria, and processes.
          The Company is not a party to (nor receives any fee for), and is not
          responsible for, any transaction, communication, or relationship
          between you and any Onboarded Organization.
        </li>
      </ul>
      <p>
        As stated in the Disclaimer of Warranties below, the Company
        specifically disclaims any scores or results obtained from tools
        available on the Data Hub, and information available on the Data Hub
        should not be used to advise on the eligibility and/or quality of
        potential borrowers or entities. Onboarded Organizations: You must
        conduct your own due diligence.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>2. Eligibility and Account Registration</h2>
      <p>
        Access to the Data Hub is limited to businesses and organizations using
        it for legitimate business purposes, and to individuals who are at least
        18 years of age and authorized to act on behalf of such a business or
        organization. The Data Hub is not intended for personal, household, or
        consumer use.
      </p>
      <p>
        You may be required to register and create login credentials to access
        certain features of the Data Hub. You agree to:
      </p>
      <ul>
        <li>
          provide accurate, current, and complete information during
          registration and to keep that information up to date;
        </li>
        <li>
          maintain the security and confidentiality of your login credentials
          and not share them with, or permit their use by, any third party;
        </li>
        <li>
          be solely responsible for all activity that occurs under your account
          or credentials; and
        </li>
        <li>
          promptly notify the Company of any unauthorized use of your account or
          any other suspected breach of security.
        </li>
      </ul>
      <p>
        You are responsible for ensuring that anyone you authorize to use the
        Data Hub under your account complies with these Terms. If we believe
        your account has been compromised, we may suspend or disable it. If you
        would like to learn more about how we handle the data you provide us
        with, please see our Privacy Policy.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>3. Onboarded Organizations</h2>
      <p>
        This Section applies to Onboarded Organizations — organizations that
        register with and are onboarded to the Data Hub to offer or make
        available resources, services, or financing to businesses through the
        platform. If you access or use the Data Hub on behalf of an Onboarded
        Organization, you agree to the following on its behalf and represent
        that you are authorized to do so.
      </p>
      <p>
        <strong>Authority to share information.</strong> You represent and
        warrant that, with respect to any information, content, materials, or
        data you share or submit through the Data Hub on behalf of your
        organization or on behalf of a business, you have all rights,
        permissions, consents, and authority necessary to share that information
        through the Data Hub and to grant the licenses set forth in these Terms
        and the EULA. You are responsible for ensuring that such information is
        accurate and that its submission and use through the Data Hub does not
        violate any applicable law or the rights of any third party.
      </p>
      <p>
        <strong>Use of logos and identifying marks.</strong> By uploading or
        providing your organization’s name, logo, or other identifying marks
        (“Marks”), you grant the Company a non-exclusive, royalty-free,
        worldwide license to display, reproduce, and use such Marks for the
        purpose of identifying, highlighting, and promoting your organization as
        an Onboarded Organization on or in connection with the Data Hub and the
        Company’s related materials. You represent and warrant that you have the
        right to grant this license. The Company will use the Marks consistent
        with any reasonable usage guidelines you provide in writing, and will
        cease use of the Marks within a commercially reasonable period following
        your written request and the termination of your organization’s
        participation in the Data Hub.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>
        4. Acceptable Use – Accurate, Business-Related, and Lawful Information
      </h2>
      <p>
        The integrity of the Data Hub depends on the quality of the information
        our users provide. Accordingly, when you submit, upload, enter, or
        otherwise make available any information, content, or data through the
        Data Hub (“End User Data”), you represent, warrant, and agree that the
        End User Data:
      </p>
      <ul>
        <li>
          is accurate, truthful, and complete to the best of your knowledge, and
          is kept current;
        </li>
        <li>
          is business-related and submitted for legitimate business purposes
          consistent with the intended use of the Data Hub;
        </li>
        <li>
          does not contain false, misleading, fraudulent, or deceptive
          information;
        </li>
        <li>
          is information that you have all necessary rights, permissions, and
          consents to provide; and
        </li>
        <li>
          does not contain anything unlawful or otherwise prohibited under these
          Terms.
        </li>
      </ul>
      <p>
        You are solely responsible for your End User Data and for verifying its
        accuracy before submitting it. The Company relies on the accuracy of End
        User Data but does not independently verify it and is not responsible
        for it. Notwithstanding the foregoing, Company reserves its right to
        remove any End User Data from the Data Hub that it has reason to believe
        fails to meet the foregoing representations and warranties.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>5. Prohibited Conduct</h2>
      <p>
        You agree that you will not, and will not permit any third party to, use
        the Data Hub to upload, submit, transmit, or otherwise make available
        any End User Data, or to take any action, that:
      </p>
      <ul class="alphabetical-list">
        <li>
          (a) violates any applicable foreign, federal, state, local, or
          provincial law, ordinance, regulation, or administrative order;
        </li>
        <li>
          (b) infringes any copyright, trademark, patent, trade secret, or other
          intellectual property or proprietary right of any third party;
        </li>
        <li>
          (c) violates or infringes upon any party’s privacy rights, right of
          publicity, or any other right of any person or entity;
        </li>
        <li>
          (d) is unlawful, fraudulent, hateful, obscene, libelous, threatening,
          harassing, defamatory, or otherwise objectionable;
        </li>
        <li>
          (e) contains any viruses, worms, trap doors, time bombs, clocks,
          counters, malware, or other harmful, malicious, or limiting routines,
          instructions, or designs;
        </li>
        <li>
          (f) is false, inaccurate, or misleading, or that misrepresents your
          identity, affiliation, or business;
        </li>
        <li>
          (g) attempts to circumvent any security device, or to access, derive,
          or reverse engineer the source code, architecture, or underlying
          technology of the Data Hub;
        </li>
        <li>
          (h) interferes with, disrupts, degrades, or imposes an unreasonable
          burden on the Data Hub or the servers or networks supporting it,
          including any load or penetration testing not authorized in writing by
          the Company;
        </li>
        <li>
          (i) uses the Data Hub to build, or assist any third party in building,
          a competing product or service, or for any benchmarking or
          competitive-analysis purpose;
        </li>
        <li>
          (j) uses any robot, spider, scraper, or other automated means to
          access, monitor, or copy the Data Hub or its contents except as
          expressly authorized in writing by the Company; or
        </li>
        <li>
          (k) attempts to gain unauthorized access to any account, system, or
          data, or otherwise uses the Data Hub in any manner that could damage,
          disable, overburden, or impair it or interfere with any other party’s
          use of it.
        </li>
      </ul>
      <p>
        The Company may investigate any suspected violation of these Terms and
        may take any action it deems appropriate, including removing End User
        Data, suspending or terminating access, and reporting conduct to law
        enforcement.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>6. End User Data and License to the Company</h2>
      <p>
        As between you and the Company, you retain such rights as you have in
        your End User Data, subject to the licenses granted in these Terms and
        the EULA. By uploading or otherwise providing End User Data, you grant
        the Company a limited, non-exclusive license to host, store, display,
        reproduce, and make available such End User Data for access by the
        Company and other Data Hub users in connection with the operation of the
        Data Hub.
      </p>
      <p>
        You acknowledge and agree that the Company may share your End User Data
        with other users of the Data Hub and may analyze anonymized and
        aggregated versions of End User Data. The Company has no obligation to
        monitor End User Data; however, if the Company becomes aware that any
        item you submit does or may violate any representation, warranty, or
        restriction in these Terms or the EULA, the Company has the right to
        remove or disable access to such item pending resolution, and the
        parties agree to work together promptly and in good faith to remedy the
        issue.
      </p>
      <p>
        All collection and use of information through the Data Hub is governed
        by the Privacy Policy. By using the Data Hub and providing information
        through it, you consent to all actions taken by us with respect to your
        information in compliance with the Privacy Policy.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>7. Intellectual Property and Reservation of Rights</h2>
      <p>
        The Data Hub is licensed, not sold, to you. All right, title, and
        interest in and to the Data Hub and all underlying software, technology,
        content, and other intellectual property — including all copyrights,
        trademarks, patents, and other intellectual property rights therein or
        relating thereto — belong exclusively to the Company or its licensors
        and service providers. Except for the limited rights expressly granted
        to you under the EULA and these Terms, you acquire no ownership interest
        in the Data Hub or the information provided through it. You shall not
        remove, alter, or obscure any copyright, trademark, patent, or other
        proprietary rights notices contained in or accessible through the Data
        Hub.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>8. Updates and Modifications to the Data Hub</h2>
      <p>
        The Company may, from time to time and in its sole discretion, develop
        and provide updates to the Data Hub, which may include upgrades, bug
        fixes, patches, other error corrections, and/or new features
        (collectively, “Updates”). Updates may also modify or delete certain
        features and functionality in their entirety. You agree that the Company
        has no obligation to provide any Updates or to continue to provide or
        enable any particular features or functionality, and may remove any of
        the foregoing in its sole discretion. All Updates will be deemed part of
        the Data Hub and subject to these Terms and the EULA.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>9. Third-Party Materials</h2>
      <p>
        The Data Hub may display, include, or make available third-party content
        or provide links to third- party websites or services (“Third-Party
        Materials”). The Company is not responsible for Third- Party Materials,
        including their accuracy, completeness, timeliness, validity, copyright
        compliance, legality, decency, quality, or any other aspect thereof, and
        does not assume and will not have any liability or responsibility to you
        or any other person or entity for any Third-Party Materials. Third-Party
        Materials and links thereto are provided solely as a convenience to you,
        and you access and use them entirely at your own risk and subject to
        such third parties’ terms and conditions, which we recommend you review
        prior to accessing such Third-Party Materials.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>10. Free Access; Trial Period</h2>
      <p>
        Where access to the Data Hub is provided to you free of charge, you
        acknowledge and agree that your access and any assistance provided to
        you may be limited. The Company reserves the right to limit, suspend, or
        terminate your access to the Data Hub at any time and for any reason,
        with notice to you. Any free trial access is provided for evaluation
        purposes only and is governed by the applicable ACC Data Hub Trial
        Period Terms and Conditions, which control in the event of any conflict
        with these Terms with respect to trial access.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>11. Disclaimer of Warranties</h2>
      <p>
        THE DATA HUB IS PROVIDED TO YOU “AS IS” AND “AS AVAILABLE,” WITH ALL
        FAULTS AND DEFECTS AND WITHOUT WARRANTY OF ANY KIND. TO THE MAXIMUM
        EXTENT PERMITTED UNDER APPLICABLE LAW, THE COMPANY, ON ITS OWN BEHALF
        AND ON BEHALF OF ITS AFFILIATES AND ITS AND THEIR RESPECTIVE LICENSORS
        AND SERVICE PROVIDERS, EXPRESSLY DISCLAIMS ALL WARRANTIES, WHETHER
        EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING ALL IMPLIED
        WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE,
        AND NON- INFRINGEMENT, AND WARRANTIES THAT MAY ARISE OUT OF COURSE OF
        DEALING, COURSE OF PERFORMANCE, USAGE, OR TRADE PRACTICE. THE COMPANY
        MAKES NO REPRESENTATION OR WARRANTY THAT THE DATA HUB WILL MEET YOUR
        REQUIREMENTS, BE SECURE, ACCURATE, OR ERROR-FREE, ACHIEVE ANY INTENDED
        RESULTS, OR OPERATE WITHOUT INTERRUPTION.
      </p>
      <p>
        NOTWITHSTANDING THE FOREGOING, AND IN NO WAY LIMITING THE FOREGOING
        DISCLAIMER, THE COMPANY SPECIFICALLY DISCLAIMS ANY SCORES OR RESULTS
        OBTAINED FROM TOOLS AVAILABLE ON THE DATA HUB, AND IN NO WAY SHOULD THE
        INFORMATION AVAILABLE ON THE DATA HUB BE USED TO ADVISE ON THE
        ELIGIBILITY AND/OR QUALITY OF POTENTIAL BORROWERS OR ENTITIES. YOU MUST
        CONDUCT YOUR OWN DUE DILIGENCE AND EXAMINE AND ASSESS THE INFORMATION
        PROVIDED FOR YOURSELF. THE COMPANY ALSO IN NO WAY GUARANTEES THAT USE OF
        THE DATA HUB BY ONBOARDED ORGANIZATIONS WILL RESULT IN ANY BUSINESS FOR
        YOU, OR THE PROVISION OF ELIGIBLE BORROWERS THAT YOU MAY DO BUSINESS
        WITH. FOR BUSINESSES, THE COMPANY IN NO WAY GUARANTEES THAT USE OF THE
        DATA HUB WILL RESULT IN YOU BEING ABLE TO OBTAIN FINANCING OR OTHER
        DESIRED SERVICES, OR ON TERMS DESIRABLE TO YOU.
      </p>
      <p>
        THE COMPANY WILL NOT BE LIABLE FOR ANY PROBLEMS WITH THE DATA HUB
        ATTRIBUTABLE TO THE INTERNET, AN UNFORSEEABLE AND UNAVOIDABLE EVENT, OR
        YOUR OR ANY AUTHORIZED USER’S NETWORK OR ABILITY TO ACCESS THE INTERNET.
        SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES, SO
        SOME OR ALL OF THE ABOVE EXCLUSIONS MAY NOT APPLY TO YOU.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>12. Limitation of Liability</h2>
      <p>
        TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL THE
        COMPANY OR ITS AFFILIATES, OR ANY OF ITS OR THEIR RESPECTIVE LICENSORS
        OR SERVICE PROVIDERS, HAVE ANY LIABILITY ARISING FROM OR RELATED TO YOUR
        USE OF OR INABILITY TO USE THE DATA HUB OR THE CONTENT AND SERVICES FOR
        PERSONAL INJURY, PROPERTY DAMAGE, LOST PROFITS, COST OF SUBSTITUTE GOODS
        OR SERVICES, LOSS OF DATA, LOSS OF GOODWILL, BUSINESS INTERRUPTION,
        COMPUTER FAILURE OR MALFUNCTION, OR ANY OTHER CONSEQUENTIAL, INCIDENTAL,
        INDIRECT, EXEMPLARY, SPECIAL, OR PUNITIVE DAMAGES.
      </p>
      <p>
        THE COMPANY’S AGGREGATE LIABILITY TO YOU ARISING UNDER OR IN CONNECTION
        WITH THESE TERMS, WHETHER IN CONTRACT, TORT (INCLUDING NEGLIGENCE), OR
        OTHERWISE, WILL NOT EXCEED THE GREATER OF (A) THE AMOUNT ACTUALLY PAID
        BY YOU, IF ANY, FOR ACCESS TO THE DATA HUB, OR (B) USD 50.00 (FIFTY US
        DOLLARS).
      </p>
      <p>
        THE FOREGOING LIMITATIONS WILL APPLY WHETHER SUCH DAMAGES ARISE OUT OF
        BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE), OR OTHERWISE, AND
        REGARDLESS OF WHETHER SUCH DAMAGES WERE FORESEEABLE OR THE COMPANY WAS
        ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. SOME JURISDICTIONS DO NOT
        ALLOW CERTAIN LIMITATIONS OF LIABILITY, SO SOME OR ALL OF THE ABOVE
        LIMITATIONS MAY NOT APPLY TO YOU.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>13. Indemnification</h2>
      <p>
        You agree to indemnify, defend, and hold harmless the Company and its
        officers, directors, employees, agents, affiliates, successors, and
        assigns from and against any and all losses, damages, liabilities,
        deficiencies, claims, actions, judgments, settlements, interest, awards,
        penalties, fines, costs, or expenses of whatever kind, including
        reasonable attorneys’ fees, arising from or relating to (a) your End
        User Data or any other content or materials you input to, store in, or
        process through the Data Hub; (b) your use or misuse of the Data Hub; or
        (c) your breach of these Terms or the EULA.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>14. Suspension and Termination</h2>
      <p>
        These Terms apply while you access or use the Data Hub. The Company may
        suspend or terminate your access to the Data Hub at any time, with or
        without notice, including if you violate these Terms or the EULA, if the
        Company ceases to support the Data Hub, or if you fail to make any
        subscription payment due to the Company, if any. You may terminate your
        access and use of the Data Hub at any time, in your sole discretion.
        Upon termination, all rights granted to you will terminate and you must
        cease all use of the Data Hub. Termination will not limit any of the
        Company’s rights or remedies at law or in equity. Provisions that by
        their nature should survive termination — including those relating to
        End User Data, intellectual property, disclaimers, limitation of
        liability, indemnification, and governing law — will survive.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>15. Changes to These Terms</h2>
      <p>
        The Company may revise these Terms from time to time in its sole
        discretion. When we do, we will update the “Last Updated” date above.
        Material changes may be communicated through the Data Hub or by other
        reasonable means. Your continued access to or use of the Data Hub after
        revised Terms become effective constitutes your acceptance of the
        revised Terms. If you do not agree to the revised Terms, you must stop
        using the Data Hub.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>16. Governing Law and Venue</h2>
      <p>
        These Terms are governed by and construed in accordance with the
        internal laws of the Commonwealth of Virginia, without giving effect to
        any choice or conflict of law provision or rule. Any legal suit, action,
        or proceeding arising out of or related to these Terms or the Data Hub
        shall be instituted exclusively in the federal courts of the United
        States or the courts of the Commonwealth of Virginia, in each case
        located in Montgomery County. You waive any and all objections to the
        exercise of jurisdiction over you by such courts and to venue in such
        courts.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>17. Miscellaneous</h2>
      <p>
        <strong>Entire Agreement.</strong> These Terms, together with the EULA,
        the applicable Trial Period Terms and Conditions, and the Privacy
        Policy, constitute the entire agreement between you and the Company with
        respect to the Data Hub and supersede all prior or contemporaneous
        understandings and agreements, whether written or oral, with respect to
        the Data Hub.
      </p>
      <p>
        <strong>Severability.</strong> If any provision of these Terms is
        illegal or unenforceable under applicable law, the remainder of the
        provision will be amended to achieve as closely as possible the effect
        of the original term, and all other provisions will continue in full
        force and effect.
      </p>
      <p>
        <strong>Waiver.</strong> No failure to exercise, and no delay in
        exercising, any right or power under these Terms will operate as a
        waiver, nor will any single or partial exercise of any right or power
        preclude further exercise of that or any other right. All waivers must
        be in writing.
      </p>
      <p>
        <strong>Assignment.</strong> These Terms are personal to you, and you
        may not assign or transfer any of your rights or obligations under them
        without the prior written consent of the Company. The Company may assign
        these Terms without restriction.
      </p>
      <p>
        <strong>Order of Precedence.</strong> In the event of a conflict among
        these Terms, the EULA, and the Trial Period Terms and Conditions, the
        EULA shall govern as to its subject matter, the Trial Period Terms and
        Conditions shall govern as to free trial access, and these Terms shall
        govern as to all other matters.
      </p>
    </div>

    <div class="terms-of-use__section">
      <h2>18. Contact Us</h2>
      <p>If you have questions about these Terms, please contact:</p>
      <p>
        <strong>ACC Data Hub LLC</strong><br />
        Attn: ACC Data Hub – Terms of Use<br />
        110 Peppers Ferry Road NW, Christiansburg, VA 24073<br />
        info&#64;accdata.org
      </p>
    </div>
  </div>
</div>
